import { useTranslation } from 'react-i18next';

import { Notification } from '../../various/Notification';

import { WishlistShareLinkInput } from './WishlistShareLinkInput';

interface Props {
  isError: boolean;
  isPending: boolean;
  lookbookId: string;
  wishlistId?: string;
}

export const WishlistShareForm = ({ isPending, wishlistId, lookbookId, isError }: Props) => {
  const { t } = useTranslation(['selections', 'lookbook']);

  return (
    <div className="flex flex-col gap-6">
      <p className="body-2">{t('lookbook:share_wishlist_description')}</p>
      <div className="relative">
        {isError ?
          <Notification type="error" isBordered message={t('lookbook:share_wishlist_error')} />
        : <WishlistShareLinkInput isPending={isPending} wishlistId={wishlistId} lookbookId={lookbookId} />}
      </div>
    </div>
  );
};
